import { queryOptions } from '@tanstack/react-query';
import type { PermissionsResponseDTO } from '@tempo-io/id-dto';
import { permissionQueryKeys } from 'src/lib/query-keys/permissions';
import { tempoApi } from '@/lib/api/tempoApi';

export const permissionsQueryOptions = queryOptions({
  queryKey: permissionQueryKeys.all(),
  queryFn: async () => {
    const response = await tempoApi().get('api/permissions/v1');
    return response.json<PermissionsResponseDTO>();
  },
  staleTime: Infinity,
  gcTime: Infinity,
});
